
import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { Badge, Button, Card, Col, Dropdown, Modal, Table } from "react-bootstrap"
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";

import moment from "moment";
import { GetAllStates, GetDistricts } from '../../../services/CommonService';
import EventBus from '../../../services/EventBus';

const AddDistricts = lazy(() => import('./AddDistricts'));
const Districts = () => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [postModal, setPostModal] = useState(false);
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect x="0" y="0" width="24" height="24"></rect>
                <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                <circle fill="#000000" cx="19" cy="12" r="2"></circle>
            </g>
        </svg>
    );
    const [data, setData] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [stateid, setStateId] = useState(null);
    const [tenantlist, setTenantList] = useState([]);
    const [tenantdata, setTenantData] = useState({});
    const [updateitem, setUpdateItem] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [states, setstates] = useState([]);
    const [statedata, setStateData] = useState({});
  
    useEffect(() => {
        getStates()
        EventBus.on("loadpagedata", (data) => {
            let obj = {
                payload: {
                    "pageNo": data?.message?.page,
                    "size": 10
                }
            }
            loadData(data?.message?.page);
            //dispatch(fetchAllPaitentsForMedicalBoard({obj:obj}));
        });
        EventBus.remove("loadpagedata");
    }, [stateid]);

    const handlePageChange = async (pn) => {
        if (pn !== activePage && !isNaN(pn)) {
            loadNextsetofRecords(pn);
        }
    };
    const loadNextsetofRecords = async (pn) => {
        setActivePage(pn);
        EventBus.dispatch("loadpagedata", {
            message: {
                "page": pn
            }

        });
    };
 
    const loadData = async (pn) => {


        const reqparams = {
            pageno: pn,
            query: { stateid: stateid }
        }
        const respData = await GetDistricts(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);
    }

    const getDatalist = async (stateid) => {
        let reqparams = null;

        if (stateid == null) {
            reqparams = {
                pageno: '1'
            }
        } else {
            reqparams = {
                pageno: '1',
                query: { stateid: stateid }
            }
        }

        const respData = await GetDistricts(reqparams);
        setData(respData.data.docs);
        setTotalRecords(respData.data.totalDocs);

    }


    const getStates = async () => {
        const reqdata = {
            pageno: '-1',
            query: { status: 'Active' },

        }

        const Response = await GetAllStates(reqdata);
        setstates(Response.data);
    }

    const openModal = async () => {
        if (stateid == null) {
            notifyTopFullWidth("Please choose state");
        }
        else {
            setPostModal(true);
        }
    }

  

    const handleChange = async(e) => {
        const { name, value } = e.target;
        setStateId(value);
        const statedata = states.filter(t => t.id == value);
        setStateData(statedata[0]);
        getDatalist(value);
        setTenantList(statedata[0].tenant);
        


    }

    const closemodal = async () => {

        getDatalist(stateid);
        setPostModal(false);
    }

    const updateData = async (item) => {

        setUpdateItem(item);
        setPostModal(true);
    }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <Col lg={12}>
                <Card>
                    <Card.Header>

                        <Card.Title>Districts <Button onClick={() => openModal(1, '')}
                            className="me-2" variant="primary btn-square"
                            title="Add University"
                        >
                            <span className="btn-icon-start text-danger">
                                <i className="fa fa-plus color-danger" />
                            </span>
                            ADD
                        </Button>


                        </Card.Title>
                        <div className="col-lg-3">
                            <select className="form-control" name="stateid"
                                value={stateid} onChange={handleChange}>
                                <option value=''>Select State</option>
                                {states.map(item => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        
                    </Card.Header>
                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>
                                        <strong>Display Position</strong>
                                    </th>
                                    <th>
                                        <strong>State Name</strong>
                                    </th>
                                    <th>
                                        <strong>District Name</strong>
                                    </th>
                                    <th>
                                        <strong>Tenant Name</strong>
                                    </th>
                                   
                                    <th>
                                        <strong>Status</strong>
                                    </th>

                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(item => (
                                    <tr>
                                        <td>
                                            <strong>{item.position}</strong>
                                        </td>
                                        <td>
                                            <strong>{item.statename}</strong>
                                        </td>
                                        <td>
                                            <strong>{item?.name}</strong>
                                        </td>
                                        <td>{displayTenants(item.tenant)}</td>
                                       
                                        <td>{item.status}</td>
                                        <td></td>

                                        <td>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    className="light sharp i-false"
                                                >
                                                    {svg1}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item>
                                                        <Link  onClick={() => updateData(item)}>
                                                            Update
                                                        </Link>

                                                    </Dropdown.Item >

                                     



                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>

                        <div >

                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={10}
                                totalItemsCount={totalRecords}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                activeClass="active"
                                itemClass="page-item"
                                innerClass="pagination mb-0"
                                linkClass="page-link"
                                firstPageText="First"
                                lastPageText="Last"
                                prevPageText="Previous"
                                nextPageText="Next"
                                disabledClass="disabled"
                                activeLinkClass="disabled"
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            <Modal className="modal fade" size="lg" show={postModal} onHide={setPostModal} >
                <div className="" role="document">
                    <div className="">
                        <form >
                            <div className="modal-header">

                                <button type="button" className="btn-close" onClick={closemodal} data-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">

                                <Suspense fallback={<div>Loading</div>}>
                                    <AddDistricts tenantprop={tenantlist} updateprop={updateitem} stateprops={statedata} /> </Suspense>
                            </div>
                            {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
                        </form>

                    </div>
                </div>
            </Modal>
        </>
    )

}

function displayTenants(item) {

    
    let counter =0;
    let retdata ='';
    for (var j = 0; j < item.length; j++){

        // console.log(item[j]);
        if(retdata ==''){
            retdata =item[j].label;
        }else{
            retdata =retdata+','+ item[j].label;
        }
        if(counter == item.length-1){
          return retdata;
        }

        counter++;
        
        }
}
export default Districts